import {useReports} from '@sail/observability';
import {once} from '@sail/utils';
import {createContext, useContext} from 'react';
import {defaultNavigationConfig} from 'src/internal/config/defaultConfig';

import type {Errors} from '@sail/observability';
import type {NavigationConfigInternal} from 'src/types';

class NavigationConfigError extends Error {
  constructor(message: string) {
    super(`[@sail/navigation] ${message}`);
  }
}

export const uninitializedNavigationConfigError = (): NavigationConfigError =>
  new NavigationConfigError(
    'Make sure to provide the required config for navigation to NavigationProvider upon initialization.',
  );

const reportUninitializedErrorOnce = once((reportError: Errors['warning']) => {
  reportError(uninitializedNavigationConfigError(), {
    tags: {namespace: 'navigation'},
  });
});

export const NavigationConfigContext = createContext<
  NavigationConfigInternal | undefined
>(defaultNavigationConfig);

export function useNavigationConfig(): NavigationConfigInternal {
  const config = useContext(NavigationConfigContext);
  const {error} = useReports();

  if (!config) {
    reportUninitializedErrorOnce(error);

    throw uninitializedNavigationConfigError();
  }

  return config;
}
